<template>
    <a-modal
        :maskClosable="false"
            title="会员优惠配置"
            :width="800"
            v-model="visibleModel"
            @cancel="handleCancel"
            @ok="handleOk"
    >
        <a-spin :spinning="saveLoading">
            <a-form :form="form">

                <a-form-item
                        label="是否开启会员优惠功能"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <r-switch :formData="formData" field="open_member_discount" :checkedValue="1" :unCheckedValue="2"
                              checkedChildren="开启" unCheckedChildren="关闭"/>
                </a-form-item>

                <a-form-item
                        v-show="formData.open_member_discount==1"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="规则配置"
                        hasFeedback
                >
                    <a-radio-group v-model="formData.member_discount_setting_mode" buttonStyle="solid">
                        <a-radio-button :value="1">以全局配置为准</a-radio-button>
                        <a-radio-button :value="2">该分类单独配置</a-radio-button>
                    </a-radio-group>
                </a-form-item>


                <div>

                    <!--                    <a-form-item-->
                    <!--                            v-show="formData.open_member_discount==1"-->
                    <!--                            :labelCol="labelCol"-->
                    <!--                            :wrapperCol="wrapperCol"-->
                    <!--                            label="奖励模式"-->
                    <!--                            hasFeedback-->
                    <!--                    >-->
                    <!--                        <a-radio-group v-model="formData.member_discount_mode" buttonStyle="solid">-->
                    <!--                            &lt;!&ndash;                    <a-radio-button :value="1">统一设置</a-radio-button>&ndash;&gt;-->
                    <!--                            <a-radio-button :value="2">按会员特权卡设置</a-radio-button>-->
                    <!--                        </a-radio-group>-->
                    <!--                    </a-form-item>-->

                    <a-table
                            v-show="formData.open_member_discount==1 && formData.member_discount_setting_mode==2"
                            :columns="sellerGroupColumns" :dataSource="formData.memberDiscountList"
                            :locale="{emptyText:'请先配置会员特权卡'}" :pagination="false" rowKey="id" bordered>
                        <template slot="sellerPercent" slot-scope="text,record">
                            <a-radio-group v-model="record.member_discount_type" buttonStyle="solid">
                                <a-radio :value="'discount'">按折扣优惠</a-radio>
                                <a-radio :value="'reduce'">按金额优惠</a-radio>
                            </a-radio-group>
                            <!--            <a-input type="number"  v-model="record.seller_percent" placeholder="千分之几"/>-->
                        </template>
                        <template slot="teamPercent" slot-scope="text,record">
                            <PriceInput
                                    v-if="record.member_discount_type == 'discount'"
                                    :formData="record"
                                    field="member_discount_value"
                                    placeholder="范围为0~9.9"/>
                            <!--                        <a-input type="number" v-model="record.member_discount_value" placeholder="请输入优惠金额"/>-->
                            <PriceInput :formData="record"
                                        v-else
                                        field="member_discount_value"
                                        placeholder="请输入优惠金额"/>
<!--                            <a-input type="number" v-model="record.member_discount_value"-->
<!--                                     v-if="record.member_discount_type == 'discount'" placeholder="范围为1~99（十分之几）"/>-->
<!--                            <a-input type="number" v-model="record.member_discount_value" v-else placeholder="请输入优惠金额"/>-->
                        </template>
                        <template slot="sellerPercentTitle">
                            优惠类型
                            <a-popover content="请选择优惠类型">
                                <a-icon type="question-circle"/>
                            </a-popover>
                        </template>
                        <template slot="teamPercentTitle">
                            设置优惠折扣或优惠金额
                            <a-popover content="请设置优惠折扣或优惠金额">
                                <a-icon type="question-circle"/>
                            </a-popover>
                        </template>
                    </a-table>


                    <!--                    <a-form-item-->
                    <!--                            v-show="formData.open_member_discount==1&& formData.member_discount_mode==1&&formData.seller_reward_goods_mode==1"-->
                    <!--                            :labelCol="labelCol"-->
                    <!--                            :wrapperCol="wrapperCol"-->
                    <!--                            label="分销员提成"-->
                    <!--                            hasFeedback-->
                    <!--                            extra="分销员提成=完成订单实际支付商品金额的千分之几"-->
                    <!--                    >-->
                    <!--                        <a-input type="number" v-decorator="[-->
                    <!--          'seller_reward_percent',-->
                    <!--          {rules: [{ required: true, message: '请输入比例' }]}-->
                    <!--        ]"-->
                    <!--                                 placeholder="请输入比例"/>-->
                    <!--                    </a-form-item>-->
                    <!--                    <a-form-item-->
                    <!--                            v-show="formData.open_member_discount==1&& formData.member_discount_mode==1&&formData.seller_reward_goods_mode==1"-->
                    <!--                            :labelCol="labelCol"-->
                    <!--                            :wrapperCol="wrapperCol"-->
                    <!--                            label="团长提成"-->
                    <!--                            hasFeedback-->
                    <!--                            extra="团长提成=完成订单实际支付商品金额的千分之几"-->
                    <!--                    >-->
                    <!--                        <a-input type="number" v-decorator="[-->
                    <!--          'team_reward_percent',-->
                    <!--          {rules: [{ required: true, message: '请输入比例' }]}-->
                    <!--        ]"-->
                    <!--                                 placeholder="请输入比例"/>-->
                    <!--                    </a-form-item>-->

                    <!--                    <a-table-->
                    <!--                            v-show="formData.open_member_discount==1&& formData.member_discount_mode==2&&formData.seller_reward_goods_mode==1"-->
                    <!--                            :columns="sellerGroupColumns" :dataSource="formData.sellerGroupRewardList"-->
                    <!--                            :locale="{emptyText:'请先配置销售用户组'}" :pagination="false" rowKey="id" bordered>-->
                    <!--                        <template slot="sellerPercent" slot-scope="text,record,index">-->
                    <!--                            <a-input type="number" v-model="record.seller_percent" placeholder="千分之几"/>-->
                    <!--                        </template>-->
                    <!--                        <template slot="teamPercent" slot-scope="text,record,index">-->
                    <!--                            <a-input type="number" v-model="record.team_percent" placeholder="千分之几"/>-->
                    <!--                        </template>-->
                    <!--                        <template slot="sellerPercentTitle">-->
                    <!--                            销售提成比例-->
                    <!--                            <a-popover content="请设置千分之几">-->
                    <!--                                <a-icon type="question-circle"/>-->
                    <!--                            </a-popover>-->
                    <!--                        </template>-->
                    <!--                        <template slot="teamPercentTitle">-->
                    <!--                            团长提成比例-->
                    <!--                            <a-popover content="请设置千分之几">-->
                    <!--                                <a-icon type="question-circle"/>-->
                    <!--                            </a-popover>-->
                    <!--                        </template>-->
                    <!--                    </a-table>-->

                    <!--                    <a-table-->
                    <!--                            v-show="formData.open_member_discount==1&&formData.seller_reward_goods_mode==2 && skuTable.sku_list.length"-->
                    <!--                            :columns="skuColumns" :dataSource="skuTable.sku_list" :pagination="false" rowKey="key"-->
                    <!--                            bordered>-->
                    <!--                        <template slot="sellerReward">-->
                    <!--                            <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllSellerReward">-->
                    <!--                                <span slot="icon"/>-->
                    <!--                                <template slot="title">-->
                    <!--                                    <PriceInput-->
                    <!--                                            :formData="setAll"-->
                    <!--                                            field="setAllSellerRewardValue"-->
                    <!--                                            placeholder="批量设置销售提成"/>-->
                    <!--                                    &lt;!&ndash;<a-input&ndash;&gt;-->
                    <!--                                    &lt;!&ndash;v-model="setAllSellerRewardValue"&ndash;&gt;-->
                    <!--                                    &lt;!&ndash;placeholder="批量设置销售提成" />&ndash;&gt;-->
                    <!--                                </template>-->
                    <!--                                销售提成-->
                    <!--                                <a-icon type="form"/>-->
                    <!--                            </a-popconfirm>-->
                    <!--                        </template>-->

                    <!--                        <template slot="teamReward">-->
                    <!--                            <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllTeamReward">-->
                    <!--                                <span slot="icon"/>-->
                    <!--                                <template slot="title">-->
                    <!--                                    <PriceInput-->
                    <!--                                            :formData="setAll"-->
                    <!--                                            field="setAllTeamRewardValue"-->
                    <!--                                            placeholder="批量设置团长提成"/>-->
                    <!--                                    &lt;!&ndash;<a-input&ndash;&gt;-->
                    <!--                                    &lt;!&ndash;v-model="setAllTeamRewardValue"&ndash;&gt;-->
                    <!--                                    &lt;!&ndash;placeholder="批量设置团长提成" />&ndash;&gt;-->
                    <!--                                </template>-->
                    <!--                                团长提成-->
                    <!--                                <a-icon type="form"/>-->
                    <!--                            </a-popconfirm>-->
                    <!--                        </template>-->


                    <!--                        <template slot="id" slot-scope="text,record,index">-->
                    <!--                            <a-input v-model="record.id" placeholder="id"/>-->
                    <!--                        </template>-->
                    <!--                        <template slot="seller_reward" slot-scope="text,record,index">-->
                    <!--                            <PriceInput v-show="formData.member_discount_mode==1"-->
                    <!--                                        :formData="record"-->
                    <!--                                        field="seller_reward"-->
                    <!--                                        placeholder="提成(元)"/>-->

                    <!--                            <PriceInput v-show="formData.member_discount_mode==2"-->
                    <!--                                        :formData="record.seller_reward_rule"-->
                    <!--                                        :field="sellerGroupSelectValue"-->
                    <!--                                        placeholder="提成(元)"/>-->
                    <!--                            &lt;!&ndash;<a-input v-show="formData.member_discount_mode==1" v-model="record.seller_reward" placeholder="提成(元)"/>&ndash;&gt;-->
                    <!--                            &lt;!&ndash;<a-input v-show="formData.member_discount_mode==2" v-model="record.seller_reward_rule[sellerGroupSelectValue]" placeholder="提成(元)"/>&ndash;&gt;-->
                    <!--                        </template>-->
                    <!--                        <template slot="team_reward" slot-scope="text,record,index">-->
                    <!--                            <PriceInput v-show="formData.member_discount_mode==1"-->
                    <!--                                        :formData="record"-->
                    <!--                                        field="team_reward"-->
                    <!--                                        placeholder="提成(元)"/>-->

                    <!--                            <PriceInput v-show="formData.member_discount_mode==2"-->
                    <!--                                        :formData="record.team_reward_rule"-->
                    <!--                                        :field="sellerGroupSelectValue"-->
                    <!--                                        placeholder="提成(元)"/>-->
                    <!--                            &lt;!&ndash;<a-input v-show="formData.member_discount_mode==1" v-model="record.team_reward" placeholder="提成(元)"/>&ndash;&gt;-->
                    <!--                            &lt;!&ndash;<a-input v-show="formData.member_discount_mode==2" v-model="record.team_reward_rule[sellerGroupSelectValue]" placeholder="提成(元)"/>&ndash;&gt;-->
                    <!--                        </template>-->
                    <!--                    </a-table>-->

                </div>


            </a-form>

        </a-spin>
        <template slot="footer">
            <a-button key="cancel" @click="handleCancel">取消</a-button>
            <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
        </template>
    </a-modal>
</template>

<script>
    import RSwitch from '@/components/RSwitch/'
    import {getCateMemberDiscountSetting, cateMemberDiscountSetting} from '@/api/goods'
    import PriceInput from '@/components/PriceInput/'

    export default {
        name: 'GoodsCateMemberDiscountForm',
        components: {
            RSwitch,
            PriceInput,
        },
        props: {
            cateId: {
                type: String | Number,
                required: true
            },
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                labelCol: {
                    xs: {span: 24},
                    sm: {span: 5},
                },
                wrapperCol: {
                    xs: {span: 24},
                    sm: {span: 12},
                },
                form: this.$form.createForm(this),
                goods: {
                    id: this.$route.query.id
                },
                saveLoading: false,
                setAll: {
                    setAllSellerRewardValue: '',
                    setAllTeamRewardValue: '',
                },
                formData: {
                    goods_id: 0,
                    open_member_discount: 1,
                    member_discount_setting_mode: 1,
                    member_discount_mode: 1,
                    // seller_reward_goods_mode: 1,
                    memberDiscountList: [],
                    // sku: [],
                    // sku_list: []
                },
                sellerGroupSelectValue: undefined,
                sku_fields_list: [],
                setAllPriceValue: '',
                skuTable: {
                    sku_fields_sets: [],
                    sku_list: [],
                },
                //表头
                sellerGroupColumns: [
                    {
                        title: '用户组',
                        width: '100px',
                        dataIndex: 'name',
                    },
                    {
                        width: '100px',
                        dataIndex: 'seller_percent',
                        slots: {title: 'sellerPercentTitle'},
                        scopedSlots: {customRender: 'sellerPercent'},
                    },
                    {
                        width: '100px',
                        dataIndex: 'team_percent',
                        slots: {title: 'teamPercentTitle'},
                        scopedSlots: {customRender: 'teamPercent'},
                    },
                ],
            }
        },
        watch: {
            cateId(value) {
                let that = this
                if (value) {
                    that.getCateMemberDiscountSetting();
                }
            }
        },
        methods: {
            handleOk(e) {
                let self = this
                e.preventDefault()
                this.form.validateFields((err, values) => {
                    if (!err) {
                        console.log('Received values of form: ', values)
                        console.log('Received valuess of formData: ', self.formData, Object.assign(self.formData, values))
                        self.formData.cate_id = self.cateId;
                        // self.formData.sku_list = JSON.stringify(self.skuTable.sku_list)
                        // self.formData.sku_list = self.skuTable.sku_list

                        cateMemberDiscountSetting(Object.assign(self.formData, values)).then(res => {
                            self.$message.success('设置成功')
                            self.saveLoading = false;
                            self.$emit('memberDiscountDone')
                        }).catch(err => {
                            self.$message.error(err.data.msg);
                            self.saveLoading = false;
                        })
                    } else {
                        console.log(err);
                    }
                })
            },
            handleCancel() {
                this.$emit('memberDiscountDone')
            },

            getCateMemberDiscountSetting() {
                let that = this
                getCateMemberDiscountSetting({cate_id: that.cateId}).then(res => {
                    that.formData = res.data;
                    that.form.setFieldsValue({...res.data})
                })
                // .catch(err =>{
                //   that.$message.error(err.data.msg)
                // })
            },
        },
        computed: {
            visibleModel: {
                get: function () {
                    return this.visible
                },
                set: function () {
                }
            },
        },
    }
</script>

<style lang="less" scoped>
</style>